// 録音した音声ファイルを置く、NGINXのパス
export const NGINX_PATH = "https://machiup.linksmart.jp/audiodata";
// 道路監視カメラ外部公開用のパス
export const NGINX_IMG_PATH = 'https://machiup.linksmart.jp/evaimg/cameraImage';
// 投稿画像を取得するパス
export const NGINX_RESIDENT_PATH = 'https://machiup.linksmart.jp/evaimg/postResident';
// 録音用serviceのパス
export const API_PATH = "https://machiup.linksmart.jp/rec";
export const CONV_STR = 'Googleによる音声文字変換...';
export const TRANS_STR = 'Translated by Google...';
export const LIMIT_DEFO = 8;
export const EVA_PATH = 'https://machiup.linksmart.jp/evaap';